import { registerSessionCleanup } from "@/shared/lib/auth"
import type { Intent } from "./intent"

type IntentAction = Intent["action"]

let pending: Intent | null = null

function matches<A extends IntentAction>(
	intent: Intent,
	actions: readonly A[],
): intent is Extract<Intent, { action: A }> {
	return actions.some((action) => action === intent.action)
}

export function setPendingIntent(intent: Intent): void {
	pending = intent
}

export function takePendingIntent<A extends IntentAction>(
	...actions: A[]
): Extract<Intent, { action: A }> | null {
	const intent = pending
	if (!intent || !matches(intent, actions)) return null
	pending = null
	return intent
}

registerSessionCleanup(() => {
	pending = null
})
